import { useCallback, useState } from "react";
import { ScreeningItem } from "../../types/Screening";
import { Loading } from "../loading/Loading";
import { useTranslation } from "react-i18next";
import { TabPanel, TabView, TabViewTabChangeEvent } from "primereact/tabview";
import { ScreeningParticulars } from "./ScreeningParticulars";
import { ScreeningSummary } from "./ScreeningSummary";
import { ScreeningGradeComparison } from "./ScreeningGradeComparison";
import { ScreeningPscPerformance } from "./ScreeningPscPerformance";
import { selectScreening } from "../../features/screeningSlice";
import { useAppSelector } from "../../redux/hooks";
import { useFlags } from "launchdarkly-react-client-sdk";
import "./ScreeningTabs.css";

type Props = {
    data: ScreeningItem | undefined;
    loading: boolean;
};

export const ScreeningTabs = (props: Props) => {
    const { data, loading } = props;

    const { t } = useTranslation("locale");

    const {
        releaseScreeningPscPerformance
    } = useFlags();

    const { pscInspections, pscLoading } = useAppSelector(selectScreening);
    
    const [activeIndex, setActiveIndex] = useState(0);

    const onTabChange = useCallback(
        (event: TabViewTabChangeEvent) => setActiveIndex(event.index),
        []
    );

    if (loading) {
        return <Loading />;
    }

    if (!data) {
        return (
            <div
                className="flex justify-content-center align-items-center h-3rem"
                style={{ backgroundColor: "#FCFCFC" }}
            >
                {t("screening.noData")}
            </div>
        );
    }

    return (
        <div className="mt-6">
            <div className="mt-3 z-0">
                <TabView activeIndex={activeIndex} onTabChange={onTabChange}>
                    <TabPanel header={t("tabs.summary")}>
                        <ScreeningSummary data={data} />
                    </TabPanel>
                    <TabPanel header={t("tabs.particulars")}>
                        <ScreeningParticulars data={data} />
                    </TabPanel>
                    <TabPanel header={t("tabs.grade_comparison")}>
                        <ScreeningGradeComparison
                            imo={`${data.vessel_imo}`}
                            vesselGrade={data}
                        />
                    </TabPanel>
                    {releaseScreeningPscPerformance ? (
                        <TabPanel header={t("tabs.psc_performance")}>
                            <ScreeningPscPerformance
                                pscInspections={pscInspections}
                                pscLoading={pscLoading}
                            />
                        </TabPanel>
                    ) : null}
                </TabView>
            </div>
        </div>
    );
};
